import { default as Icon, IconProps } from 'interface/Icon';

const icon = (props: IconProps) => <Icon icon="spell_shadow_lifedrain02" {...props} />;
export default icon;
